import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=8c0cf7c4&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=ts&"
export * from "./Accounts.vue?vue&type=script&lang=ts&"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=8c0cf7c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0cf7c4",
  null
  
)

export default component.exports